import { AbiFunction } from 'ox';
import { htlcFunctions } from '../../abi.js';
import { hex } from '../../utils.js';
export function buildRefundTx(params) {
    const data = AbiFunction.encodeData(htlcFunctions.refundUser, [hex(params.id)]);
    return { to: params.contractAddress, data };
}
